var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewstarimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 26,
    viewBox: "0 0 142 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0L15.9187 8.98278H25.3637L17.7225 14.5344L20.6412 23.5172L13 17.9656L5.35879 23.5172L8.27747 14.5344L0.636266 8.98278H10.0813L13 0Z",
    fill: "#FFC728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 0L44.9187 8.98278H54.3637L46.7225 14.5344L49.6412 23.5172L42 17.9656L34.3588 23.5172L37.2775 14.5344L29.6363 8.98278H39.0813L42 0Z",
    fill: "#FFC728"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71 0L73.9187 8.98278H83.3637L75.7225 14.5344L78.6412 23.5172L71 17.9656L63.3588 23.5172L66.2775 14.5344L58.6363 8.98278H68.0813L71 0Z",
    fill: "#FFC728"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 0L102.919 8.98278H112.364L104.723 14.5344L107.641 23.5172L100 17.9656L92.3588 23.5172L95.2775 14.5344L87.6363 8.98278H97.0813L100 0Z",
    fill: "#FFC728"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129 0L131.919 8.98278H141.364L133.723 14.5344L136.641 23.5172L129 17.9656L121.359 23.5172L124.277 14.5344L116.636 8.98278H126.081L129 0Z",
    fill: "#FFC728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewstarimg1);
export default __webpack_public_path__ + "static/media/reviewstarimg1.81ba2cf85d367c0e9501fcbd350af4ac.svg";
export { ForwardRef as ReactComponent };